import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';
import { Price } from '../../../components/Price';
import { BodySmallMuted } from '../../../components/Typography';

export const ItemWrapper = styled.div`
  width: 100%;
  padding: 20px 0;
  border-bottom: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: min-content 1fr;
  grid-row-gap: 1rem;

  ${media.tablet`
    grid-template-columns: 2fr 1fr 275px;
    grid-row-gap: 0;
    grid-column-gap: 2.5rem;

    > * {
      grid-row: 1;
    }
  `}

  ${media.lg`
    grid-template-columns: minmax(auto, 260px) 2fr 1fr 275px;
  `}
`;

export const ImageColumn = styled.div`
  display: none;

  ${media.lg`
    display: block;
  `}
`;

export const Image = styled.img`
  width: 100%;
  object-fit: cover;
  aspect-ratio: 4/3;
  display: block;
  position: relative;

  &::after {
    padding: 1rem;
    content: attr(alt);
    text-align: center;
    background-color: ${({ theme }) => theme.defaultColors.lightGrey};
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    inset: 0;
  }
`;

export const DetailsColumn = styled.div`
  grid-row: 1 / -1;
`;

export const PricingColumn = styled.div`
  display: grid;
  align-content: center;
  ${media.lg`
  display: flex;
  flex-direction: column;
  justify-self: flex-end;
  justify-content: center;
  ${media.tablet`
    text-align: right;
  `};
`}
`;

export const RoomNumberColumn = styled.div`
  border: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
  padding: 12px;
  border-radius: 6px;
  width: fit-content;

  ${media.md`
      width: 100%;
    `}
  ${media.tablet`
    text-align: left;
  `}
`;

export const ActionsColumn = styled.div`
  align-content: center;
  text-align: right;

  a {
    display: flex;
  }
`;

export const Name = styled.p`
  margin: 0 0 8px 0;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  font-size: 16px;

  ${media.md`
    margin-top: 10px;
  `}
`;

export const DescriptionWrapper = styled(BodySmallMuted)`
  margin: 2px 0;
  line-height: 21px;
`;

export const ReadMoreLink = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.customColors.secondary};
  display: inline-block;
  margin: 16px 0px;
`;

export const TermsWrapper = styled.p`
  margin: 10px 0 0;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  font-size: 15px;
`;

export const StyledPrice = styled(Price)`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  font-size: 20px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

export const PerStayIndicator = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  margin-bottom: 10px;
  margin-top: 4px;

  ${media.md`
    font-size: 15px;
  `}
`;

export const PricePerNight = styled.div`
  font-size: 15px;
  padding: 10px 0;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

export const StyledPricePerNight = styled(Price)`
  font-size: inherit;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;
